import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AIModalPayload {
  initialQuery?: string;
  userId?: string | null;
}

interface AIModalState {
  isOpen: boolean;
  initialQuery: string;
  userId: string | null;
}

const initialState: AIModalState = {
  isOpen: false,
  initialQuery: "",
  userId: null,
};

const aiModalSlice = createSlice({
  name: "aiModal",
  initialState,
  reducers: {
    openAIModal: (state, action: PayloadAction<AIModalPayload>) => {
      state.isOpen = true;
      state.initialQuery = action.payload.initialQuery || "";
      state.userId = action.payload.userId || null;
    },
    closeAIModal: (state) => {
      state.isOpen = false;
      state.initialQuery = "";
      state.userId = null;
    },
  },
});

export const { openAIModal, closeAIModal } = aiModalSlice.actions;
export default aiModalSlice.reducer;

export const selectIsAIModalOpen = (state: { aiModal: AIModalState }) =>
  state.aiModal.isOpen;
export const selectAIModalInitialQuery = (state: { aiModal: AIModalState }) =>
  state.aiModal.initialQuery;
export const selectAIModalUserId = (state: { aiModal: AIModalState }) =>
  state.aiModal.userId;
